import React, { useState } from 'react';


interface ProfileLabelValueProps {
    label: string,
    value: any,

}

const ProfileLabelValue: React.FC<ProfileLabelValueProps> = ({ label, value }) => {

    return (
        <div className='flex flex-col'>
            <p className='body3 text-neutral-500'>{label}</p>
            <div className='body3 text-primary-900'>{value}</div>
        </div>
    );
};



export default ProfileLabelValue;
